import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

interface UseIsBadgeVerificationRedesignEnabledParams {
  badgeVerificationOverride?: boolean;
}

/**
 * Hook to check if the badge verification redesign feature is enabled.
 *
 * The redesign is enabled when either:
 * - The global feature flag is enabled, OR
 * - The workplace has `badgeVerificationOverride` set to true
 *
 * @returns Whether the badge verification redesign is enabled
 */
export function useIsBadgeVerificationRedesignEnabled(
  params?: UseIsBadgeVerificationRedesignEnabledParams
): boolean {
  const isFeatureFlagEnabled = useCbhFlag(CbhFeatureFlag.BADGE_VERIFICATION_REDESIGN, {
    defaultValue: false,
  });

  return isFeatureFlagEnabled || Boolean(params?.badgeVerificationOverride);
}
